import { Fragment } from "react";
import { Formik } from "formik";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import { useComponent } from "../../../hooks";
import { objectFromFormData, validationSchema } from "./resourceObject";
import { ButtonFooter, PageHeader } from "../../../components";
import pages from "../../../constants/pages";

export default function Form({
  resource,
  editState,
  setEditState,
  formData,
  pagePermissions,
}) {
  const navigate = useNavigate();
  const { axios, alert } = useComponent();

  const { ID } = useSelector((state) => state.memberDetails.activeBot);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validateOnMount
      validationSchema={validationSchema}
      onSubmit={(formData, { setSubmitting }) => {
        axios({
          url: "/resources/add/" + ID,
          method: "POST",
          data: objectFromFormData(formData),
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            if (!formData.resourceID) {
              navigate(pages.resourceDetailsPage.route + response.data._id);
            }
            setEditState(false);

            alert.success(response.message.displayMessage);
          }
          setSubmitting(false);
        });
      }}
    >
      {(formikProps) => (
        <Fragment>
          <PageHeader
            buttons={[
              formikProps.values.isTokenGenerated && (
                <Button
                  onClick={() => {
                    setEditState(true);
                    formikProps.setValues((prev) => ({
                      ...prev,
                      isTokenGenerated: false,
                    }));
                  }}
                  variant="contained"
                >
                  Generate New Token
                </Button>
              ),
            ]}
            title="Add Resource"
            pageName={"Resource Details"}
            editIcon={[editState, setEditState, pagePermissions.update]}
          />

          <FormDisplay
            resource={resource}
            editState={editState}
            formikProps={formikProps}
            pagePermissions={pagePermissions}
          />

          <ButtonFooter
            ID={formikProps.values.resourceID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Fragment>
      )}
    </Formik>
  );
}
